<template>
  <div class="bottom">
    <div :class="isIndex ? 'auto' : 'auto_1720'">
      <div class="bottom-top clearfix">
        <router-link :to="{ name: 'Home', query: { columnId: 38 } }" v-if="!isIndex">
          <!-- <div class="title" :class="{hide: !isIndex}" v-if="lan === 0">广东省唯品会慈善基金会</div>
          <div class="title entitle" :class="{hide: !isIndex}" v-else-if="lan === 1">Guangdong vipshop Charitable Foundation</div> -->
          <div class="bottom-logo" :class="{en: lan === 1, isIndex: !isIndex}" v-if="info.data !== undefined"><img :src="info.data[0].img2" alt=""></div>
        </router-link>
        <a v-else>
          <div class="bottom-logo" :class="{en: lan === 1, isIndex: !isIndex}" v-if="info.data !== undefined"><img :src="info.data[0].img2" alt=""></div>
        </a>
        <!-- <div class="share ytable">
          <ul class="ul clearfix ytable-cell">
            <li><a rel="nofollow" @click="() => dealShare($event, 'twitter')"></a></li>
            <li><a rel="nofollow" @click="() => dealShare($event, 'facebook')"></a></li>
            <li><a rel="nofollow" @click="dealShare($event, 'sinaminiblog')"></a></li>
            <li><a rel="nofollow" @click="dealShare($event, 'weixin')"></a></li>
          </ul>
        </div> -->
      </div>
      <div class="bottom-middle clearfix">
        <div class="fl" v-if="lan === 0">
          <dl v-for="( item, index ) in menuList" :key="index">
            <dt><router-link :to="{ name: item.requestTo, query: { columnId: item.id } }">{{item.name}}</router-link></dt>
            <dd v-for="( inner, index ) in item.children" :key="index"><router-link class="dot2" :to="{ name: inner.requestTo, query: { columnId: item.id } }">{{inner.name}}</router-link></dd>
          </dl>
        </div>
        <div class="fl en" v-if="lan === 1">
          <dl v-for="( item, index ) in menuList" :key="index">
            <dt><router-link :to="{ name: item.requestTo, query: { columnId: item.id } }">{{item.enName}}</router-link></dt>
            <dd v-for="( inner, index ) in item.children" :key="index"><router-link class="dot2" :to="{ name: inner.requestTo, query: { columnId: item.id } }">{{inner.enName}}</router-link></dd>
          </dl>
        </div>
        <div class="fr clearfix">
          <div :class="isIndex ? 'qrcode hide' : 'qrcode'" v-if="info.data !== undefined">
            <div class="box"><img :src="info.data[0].img3" alt=""></div>
            <div class="txt" v-if="lan === 0">关注官方微信公众号</div>
            <div class="txt" v-else-if="lan === 1">Follow Official Account</div>
          </div>
          <div class="infor-box" v-if="info.data !== undefined && lan === 0">
            <!-- <div class="hotline infor" :class="{hide: isIndex}">服务热线：<div>{{info.data[0].phone}}</div></div> -->
            <div class="infor">联系邮箱：<div>{{info.data[0].email}}</div></div>
            <div class="infor addr">联系地址：<div>{{info.data[0].address}}</div></div>
            <div class="to-top" :class="{hide: !isIndex}" @click="toTop">返回顶部</div>
          </div>
          <div class="infor-box" v-if="info.data !== undefined && lan === 1">
            <!-- <div class="hotline infor" :class="{hide: isIndex}">Phone：<div>{{info.data[1].phone}}</div></div> -->
            <div class="infor">Mail：<div>{{info.data[1].email}}</div></div>
            <div class="infor addr">Address：<div>{{info.data[1].address}}</div></div>
            <div class="to-top" :class="{hide: !isIndex}" @click="toTop">to Top</div>
          </div>
        </div>
      </div>
      <div class="bottom-bottom ytable">
        <div class="content ytable-cell">
          <div class="links" v-if="lan === 0">
            <span><router-link :to="{ name: 'Sitemap', query: { columnId: 33 } }">网站地图</router-link></span> · <span><router-link :to="{ name: 'Law', query: { columnId: 33 } }">法律声明</router-link></span> · <span><router-link :to="{ name: 'Links', query: { columnId: 33 } }">友情链接</router-link></span>
          </div>
          <div class="links" v-else-if="lan === 1">
            <span><router-link :to="{ name: 'Sitemap', query: { columnId: 33 } }">Site Map</router-link></span> · <span><router-link :to="{ name: 'Law', query: { columnId: 33 } }">Law</router-link></span> · <span><router-link :to="{ name: 'Links', query: { columnId: 33 } }">Links</router-link></span>
          </div>
          <div class="copyright">
            <span>Copyright © 2008-2021 vip.com，All Rights Reserved  版权所有 广州唯品会电子商务有限公司 <a href="//beian.miit.gov.cn/" target="_blank" rel="nofollow">粤ICP备08114786号</a></span>
          </div>
          <div class="to-top" :class="{hide: isIndex, mar: !isIndex}" @click="toTop" v-if="lan === 0">返回顶部</div>
          <div class="to-top" :class="{hide: isIndex, mar: !isIndex}" @click="toTop" v-else-if="lan === 1">to Top</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'bottom',
  props: {
    Index: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isIndex: this.Index,
      menuList: [],
      info: this.$store.state.publicInfo,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
    }
  },
  mounted () {
    this.menuList = []
    let menuList = []
    window.addEventListener('scroll', this.scrollTop, true)
    if (localStorage.getItem('routeList') === null || localStorage.getItem('publicInfo') === null) {
      this.init()
    } else {
      try {
        menuList = JSON.parse(localStorage.getItem('routeList'))
        menuList.pop()
        menuList.shift()
        this.info = JSON.parse(localStorage.getItem('publicInfo'))
        this.menuList = menuList
      } catch (err) {
        console.log(err)
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollTop, true)
  },
  methods: {
    init () {
      this.$api.post('api/benefitArticleType/queryByParam', { isDelete: 0 }, r => {
        const menuList = []
        r.data.forEach((item) => {
          let id
          // id === 38 为首页，id === 33 为辅助栏目
          if (item.parentId === 0 && item.id !== 33 && item.id !== 38) {
            menuList.push(item)
            id = item.id
            const children = []
            r.data.forEach((item1) => {
              if (item1.parentId === id) {
                children.push(item1)
              }
            })
            menuList[menuList.length - 1].children = children
          }
        })
        this.menuList = menuList
      })
      this.$api.post('/api/benefitInfo/queryByParam', { current: 1, pageSize: 2 }, r => {
        this.info = r
      })
    },
    toTop () {
      var timer = setInterval(function () {
        const osTop = document.documentElement.scrollTop || document.body.scrollTop
        const ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
    /* eslint-disable no-undef */
    dealShare (event, type) {
      bShare.addEntry({
        url: location.href,
        title: 'Guangdong vipshop Charitable Foundation',
        summary: 'Web Sharing'
      })
      if (type !== 'more') {
        bShare.share(event, type, 0)
        return false
      } else {
        bShare.more(event)
        return false
      }
    }
  }
}
</script>
<style scoped>
.bottom{background-color: #e95da6; background-size: cover; min-width: 320px;}
.bottom .bottom-top{border-bottom: 1px solid rgba(255, 255, 255, .1); line-height: 140px;}
.bottom .bottom-logo{float: left; position: relative; min-width: 150px;}
.bottom .bottom-logo.isIndex::after{content: '返回首页>>'; color: #fff; position: absolute; left: 5%; bottom: 0; transform: translate(0, -50%); line-height: 30px; font-size: 18px;}
.bottom .bottom-logo.isIndex.en::after{content: 'Home >>';}
.bottom .title{float: left; color: #fff; font-size: 36px; font-family: 'TsangerYuYangT';}
.bottom .entitle{font-family: none;}
.bottom .share{float: right; max-width: 110px; height: 140px;}
.bottom .share ul li{margin-left: 20px; width: 40px; height: 40px; background-color: rgba(255, 255, 255, .1); float: right; border-top-left-radius: 12px; border-bottom-right-radius: 12px; cursor: pointer;}
.bottom .share li a{width: 100%; height: 100%; display: block;}
.bottom .share li:first-child a{background: url(../assets/sina.png)no-repeat center;}
/* .bottom .share li:nth-child(2) a{background: url(../assets/facebook.png)no-repeat center;}
.bottom .share li:nth-child(3) a{background: url(../assets/sina.png)no-repeat center;} */
.bottom .share li:last-child a{background: url(../assets/wechat.png)no-repeat center;}
.bottom .share li:last-child{margin-left: 0;}

.bottom .bottom-middle{padding: 5% 0;}
.bottom .fl{float: left; width: 55%; display: flex; flex-direction: row; justify-content: space-between;}
.bottom .fr{float: right; width: 38%; position: relative;}
.bottom .fl dl{display: inline-block; vertical-align: top; min-width: 100px; overflow: visible;}
.bottom .fl dl:last-child{padding-right: 0;}
.bottom .fl dt{padding-bottom: 10px; color: #fff; font-size: 16px; white-space: nowrap;}
.bottom .fl dt a{color: #fff;}
.bottom .fl dd{margin-inline-start: 0; padding: 5px 0; font-size: 16px; font-weight: lighter; color: rgba(255, 255, 255, .5);}
.bottom .fl dd a{color: rgba(255, 255, 255, .5); white-space: nowrap;}
/* .bottom .fl.en dl{padding-right: 4%;} */
.bottom .infor-box{padding-left: 170px; float: right;}
.bottom .qrcode{position: absolute; top: 0; left: 0;}
.bottom .qrcode .box{background-color: rgba(255, 255, 255, .2); border: 1px solid rgba(255, 255, 255, .2); padding: 10px; width: 132px; margin: 0 auto;}
.bottom .qrcode .txt{font-size: 14px; color: #fff; text-align: center; font-weight: lighter; padding-top: 5%;}
.bottom .infor{font-size: 16px; color: rgba(255, 255, 255, .5); font-weight: lighter;}
.bottom .infor > div{font-size: 20px; font-weight: normal; color: #fff; padding: 2% 0 8%;}
.bottom .hotline > div{font-size: 26px; font-family: 'GongfangYa';}
.bottom .addr > div{font-size: 16px;}
.bottom .to-top{font-size: 14px; padding-left: 20px; color: rgba(255, 255, 255, .5); float: right; cursor: pointer; background: url(../assets/to-top.png)no-repeat left center; margin-top: 5%;}
.bottom .to-top.mar{margin-top: 0; position: absolute; right: 0; bottom: 50px;}

.bottom .bottom-bottom{height: 140px; position: relative;}
.bottom .links,
.bottom .links a{font-size: 14px; color: #fff; font-weight: lighter;}
.bottom .links a{margin: 0 1%; cursor: pointer;}
.bottom .links span:first-child a{margin-left: 0;}
.bottom .copyright{padding-top: 1%; padding-right: 65px;}
.bottom .copyright,
.bottom .copyright a{font-weight: lighter; color: rgba(255, 255, 255, .5); font-size: 14px; transition: all .3s ease-in-out;}
.bottom .copyright a:hover{color: #fff;}
@media(max-width: 1600px){
  /* .bottom .fl dl{padding-right: 6%;} */
  .bottom .fl{width: 62%;}
}
@media(max-width: 1200px){
  .bottom .infor-box{padding-left: 0; float: none;}
  .bottom .qrcode{position: initial; width: 132px;}
  .bottom .qrcode .box{display: inline-block; width: 100%;}
}
@media(max-width: 1024px){
  .bottom .fl dt a{font-size: 15px;}
  .bottom .fl dd a{font-size: 14px;}
  .bottom .entitle{font-size: 28px;}
}
@media(max-width: 960px){
  .bottom .fl{display: none;}
  .bottom .fr{width: 100%;}
  .bottom .qrcode{margin: 0 auto;}
  .bottom .infor-box{float: none; text-align: center; padding-top: 1%;}
  .bottom .infor{padding-top: 1%;}
  .bottom .infor > div{padding: 1% 0;}
  .bottom .copyright{padding-right: 0;}
}
@media(max-width: 640px){

  .bottom .share{width: 220px;}
  .bottom .title{font-size: 26px;}
  .bottom .entitle{line-height: 1.5; padding-top: 3%; text-align: center;}

}
@media(max-width: 480px){
  .bottom .bottom-logo.isIndex.en::after,
  .bottom .bottom-logo.isIndex::after{content: none;}
  .bottom .fr{text-align: center;}
  .bottom .qrcode .box{width: 96px; margin: 0 auto;}
  .bottom .qrcode .txt{padding: 3% 0;}
  .bottom .qrcode{margin: 10px auto;}

  .bottom .copyright{line-height: 1.5; padding: 1% 2%}
  .bottom .copyright a{line-height: 1.5;}
  .bottom .share{float: none; margin: 0 0 0 auto; height: 80px;}
  .bottom .bottom-top{line-height: 80px;}
  .bottom .to-top.mar{position: initial; margin-top: 5%;}
  .bottom .content{text-align: center;}
  .bottom .title{width: 100%;}
  .bottom .entitle{font-size: 20px;}
  .bottom .links a{font-size: 12px;}
}
</style>
